export interface Shift {
  title: string;
  before: string;
  after: string;
  benefit: string;
  risk: string;
}

export const shifts: Shift[] = [
  {
    title: 'Human-authored → agent-authored code',
    before: 'Engineers write code; assistants suggest the next token.',
    after:
      'Claude Code, Cursor 3, Codex Desktop, Devin and OpenCode operate as multi-file agents. SWE-bench Verified scores cluster 60-78%. Nubank reports an 8-12× efficiency multiplier on a 6M-line migration done by a Devin fleet.',
    benefit: 'Throughput compounds on bounded, well-specified work.',
    risk:
      'Skill atrophy, IP/licensing exposure, maintenance debt on code no human ever read line by line.',
  },
  {
    title: 'Prescriptive specs → intent-based specs',
    before: 'PRDs, Figma frames, acceptance criteria. The spec is the truth.',
    after:
      'The spec is the eval. Constitutions + Given/When/Then scenarios compile to executable evaluations. CLAUDE.md / AGENTS.md sit at the repo root.',
    benefit: 'Intent captured once, consumed by humans and agents.',
    risk: 'Eval coverage is the new test coverage; most orgs have ~1% of it.',
  },
  {
    title: 'Human-in-the-loop → human-on-the-loop',
    before:
      'Every meaningful state change is human-initiated and human-approved.',
    after:
      'Approval graduates: routine work runs human-out-of-the-loop with eval gates; bounded autonomous work runs on-the-loop with sampled review; novel work stays in-the-loop.',
    benefit: 'Latency and unit cost collapse on the 80% of repetitive work.',
    risk:
      'Trust calibration becomes the hardest engineering problem in the org.',
  },
  {
    title: 'Static apps → agentic apps',
    before: 'Request/response. Stateless tier over a database.',
    after:
      'Long-running, stateful, tool-using, planning, sometimes multi-agent. Per-user persistent agents with memory, schedules, and credentials. Cloudflare Agents SDK, OpenAI Agents SDK, Letta, Mem0.',
    benefit: 'Software finally fits the shape of the work.',
    risk:
      'Cascading agent failures, cost runaway (5-30× tokens per task vs chatbot, per Gartner).',
  },
  {
    title: 'REST → MCP and A2A',
    before: 'REST, gRPC, GraphQL. APIs designed by humans for humans-code.',
    after:
      'MCP is the integration substrate for LLMs and tools (spec 2025-11-25; donated to the Linux Foundation Dec 2025; 500+ public servers; OAuth 2.1). REST APIs get wrapped, not replaced.',
    benefit: 'N×M integration collapses to N+M.',
    risk:
      'Multi-tenant auth still unstandardised; "Shadow MCP" is the new Shadow IT.',
  },
  {
    title: 'Deterministic → probabilistic systems',
    before: 'Same input, same output. Unit tests assert equality.',
    after:
      'Distributions of outputs. Evals, LLM-as-judge, pairwise comparison. SLOs include hallucination rate, refusal rate, tool-selection accuracy.',
    benefit: 'Software handles the ambiguous middle of real human work.',
    risk: 'Reproducibility, audit, and incident forensics degrade.',
  },
  {
    title: 'Ship code → ship capabilities',
    before: 'You ship features. Pricing is per-seat.',
    after:
      'You ship capabilities. Pricing moves to per-outcome, per-task, per-resolution. State of FinOps 2026 names AI as the fastest-growing new spend category.',
    benefit: 'Revenue tracks value, not seat sprawl.',
    risk: 'Token economics and inference cost are now CFO-level concerns.',
  },
  {
    title: 'Cloud-centric → edge-native',
    before: 'Centralise compute in 3-5 regions; pay egress; accept latency.',
    after:
      'Multi-hop agent workflows compound latency. Edge-native platforms co-locate inference, state, vector search and tools.',
    benefit: 'Lower p99, better residency posture, fewer glue services.',
    risk:
      'Edge is not the answer to heavy training or specialised hardware; pretending otherwise creates new lock-in.',
  },
];
